/**
 * Der Abschnitt „Stationsverlauf" des Bestell-Reiters - Portierung von `index.html:8535`
 * (`sec('main-verlauf', 'Stationsverlauf', '<div class="timeline" id="timeline"></div>')`) samt
 * `renderTimeline` (`:14167-14183`), das im Bestand die Zeilen NACH dem Zeichnen in `#timeline`
 * nachtraegt.
 *
 * Original, woertlich:
 *
 *     const h = (o.history || []).slice().reverse();
 *     tl.innerHTML = h.map((e, i) => `
 *       <div class="tl-row">
 *         <div class="tl-dot-wrap">
 *           <div class="tl-dot" style="${i === 0 ? '' : 'background:var(--line)'}"></div>
 *           ${i < h.length - 1 ? '<div class="tl-line"></div>' : ''}
 *         </div>
 *         <div class="tl-text">
 *           <div><b>${esc(STATUS_MAP[e.status]?.label || e.status)}</b></div>
 *           <div class="when">${fmtDT(e.ts)}${e.actor ? ` · ${esc(e.actor)}` : ''}</div>
 *         </div>
 *       </div>`).join('') || '<div style="color:var(--ink-faint);font-size:.85rem">Kein Verlauf.</div>';
 *
 * Drei Eigenheiten, woertlich uebernommen:
 *
 * 1. `slice().reverse()` - der JUENGSTE Eintrag steht oben. `slice()` schuetzt `o.history` vor dem
 *    umdrehenden `reverse()`; hier ebenso wichtig wie dort, weil `history` aus dem Store kommt.
 * 2. Nur der oberste Punkt bleibt farbig; alle uebrigen tragen `background:var(--line)` inline.
 *    Beim obersten steht im Bestand ein LEERES `style`-Attribut - `domSignatur` liest daraus wie bei
 *    einem fehlenden Attribut die leere Zeichenkette, beide Formen sind dort also gleich.
 * 3. Die Verbindungslinie fehlt beim LETZTEN Eintrag (`i < h.length - 1`).
 * 4. `STATUS_MAP[e.status]?.label || e.status` - ein unbekannter Status zeigt seinen Rohwert.
 */
import { fmtDT } from "../../../lib/format.ts";
import type { StatusDefinitionen } from "../../../lib/status.ts";
import type { Order } from "../../../lib/types.ts";

/** Ein Verlaufseintrag, so wie `moveOrder` (index.html:7764) ihn anlegt. */
interface Verlaufseintrag {
  ts?: unknown;
  status?: unknown;
  actor?: unknown;
}

export interface VerlaufProps {
  bestellung: Order;
  definitionen: StatusDefinitionen;
}

export function Verlauf({ bestellung: o, definitionen }: VerlaufProps) {
  const h = ((o.history || []) as Verlaufseintrag[]).slice().reverse();

  return (
    <div className="timeline" id="timeline">
      {h.length ? (
        h.map((e, i) => (
          <div className="tl-row" key={i}>
            <div className="tl-dot-wrap">
              <div className="tl-dot" style={i === 0 ? undefined : { background: "var(--line)" }} />
              {i < h.length - 1 ? <div className="tl-line" /> : null}
            </div>
            <div className="tl-text">
              <div>
                <b>{definitionen.STATUS_MAP[e.status as string]?.label || (e.status as string)}</b>
              </div>
              <div className="when">
                {fmtDT(e.ts as string)}
                {e.actor ? ` · ${e.actor as string}` : ""}
              </div>
            </div>
          </div>
        ))
      ) : (
        <div style={{ color: "var(--ink-faint)", fontSize: ".85rem" }}>Kein Verlauf.</div>
      )}
    </div>
  );
}
